import { render, staticRenderFns } from "./business-unit-form.vue?vue&type=template&id=2265f6ec&scoped=true&lang=pug&"
import script from "./business-unit-form.vue?vue&type=script&lang=ts&"
export * from "./business-unit-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2265f6ec",
  null
  
)

export default component.exports